<template>
  <div>
    <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
      <div class="row">
        <div class="col-sm my-2">
          <input
            class="form-control"
            placeholder="شماره ترمینال"
            v-model="terminal_number"
          />
        </div>
        <div class="col-sm my-2">
          <div class="form-group my-0">
            <datePicker
              color="#00c1a4"
              format="YYYY-MM-DD"
              display-format="dddd jDD jMMMM jYYYY"
              input-class="form-control"
              name="from_date"
              placeholder="دوره"
              clearable
              v-model="from_date"
              type="date"
            />
          </div>
        </div>
        <div class="col-sm my-2">
          <div>
            <button
              :class="query ? 'btn btn-success mr-2' : 'btn btn-success btn-block'"
              style="border-radius: 10px"
              @click="get_data(visitor.first_page_url)"
            >
              {{ $t('marketing.label.table_filter') }}
            </button>
            <button
              class="btn btn-danger mr-3"
              style="border-radius: 10px"
              @click="reset_and_get"
              v-if="query"
            >
              {{ $t('marketing.label.remove_filter') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-3">
      <div class="col-md-6 mt-sm-size">
        <div
          class="bg-white p-3 h-100"
          style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6"
        >
          <p class="mx-2">{{  $t('marketing.label.statistics_transaction_number_title') }}</p>
          <p class="text-center h3">{{ marketingManage.transactions_number }}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="bg-white p-3 h-100"
          style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6"
        >
          <p class="mx-2">{{ $t('marketing.label.statistics_transaction_amount_title') }}</p>
          <p class="text-center h3">
            {{ marketingManage.total_transactions_amount + " ریال" }}
          </p>
        </div>
      </div>
    </div>
    <!-- Switch -->
    <div class="switch-div" v-if="$can('read','marketing')">
      {{ $t('marketing.label.shareholder') }}
      <label class="switch m-0 mr-2 ml-2">
        <input id="settlement_checkbox" type="checkbox" v-model="checked" />
        <span class="slider round"></span>
      </label>
      {{ $t('marketing.label.self') }}
    </div>

    <div class="bg-white shadow-sm p-3 my-3 mt-sm-size" style="border-radius: 10px">
      <div
        v-if="is_init"
        class="bg-white shadow-sm py-3 my-2"
        style="border-radius: 10px"
      >
        <div class="px-3">
          <div class="table-responsive">
            <table
              class="table table-responsive table-borderless text-center"
              v-if="visitor.data.length > 0"
            >
              <thead>
                <tr>
                  <th
                    scope="col"
                    style="background-color: #eee; border-radius: 0 16px 16px 0"
                  >
                    #
                  </th>
                  <th scope="col" style="background-color: #eee">{{ $t('marketing.label.terminal_number') }}</th>
                  <th
                    scope="col"
                    style="background-color: #eee; cursor: pointer"
                    @click="sortBy('period')"
                  >
                    {{ $t('marketing.label.period') }}
                    <span v-if="sort_field == 'period'">
                      <span v-if="sort_sort == 'asc'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                          />
                        </svg>
                      </span>
                      <span v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                          />
                        </svg>
                      </span>
                    </span>
                  </th>
                  <th
                    scope="col"
                    style="background-color: #eee; cursor: pointer"
                    @click="sortBy('transaction_count')"
                  >
                    {{ $t('marketing.label.transaction_number') }}
                    <span v-if="sort_field == 'transaction_count'">
                      <span v-if="sort_sort == 'asc'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                          />
                        </svg>
                      </span>
                      <span v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                          />
                        </svg>
                      </span>
                    </span>
                  </th>
                  <th
                    scope="col"
                    style="background-color: #eee; cursor: pointer"
                    @click="sortBy('total_amount')"
                  >
                    {{ $t('marketing.label.total_amount') }}
                    <span v-if="sort_field == 'total_amount'">
                      <span v-if="sort_sort == 'asc'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path
                            d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                          />
                        </svg>
                      </span>
                      <span v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          viewBox="0 0 24 24"
                          width="16"
                          fill="#00bea5"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path
                            d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                          />
                        </svg>
                      </span>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(marketing, index) in visitor.data" :key="index">
                  <td class="en_num">{{ marketing.id }}</td>
                  <td>{{ marketing.terminal_number }}</td>
                  <td v-text="toPersianDateFormat(marketing.period)"></td>
                  <td>{{ marketing.transaction_count }}</td>
                  <td>
                    <span :class="`px-3 py-2`" v-text="marketing.total_amount"></span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="empty-table" style="height: 300px" v-else>
              <table class="table table-responsive table-borderless text-center">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      style="background-color: #eee; border-radius: 0 16px 16px 0"
                    >
                      #
                    </th>
                    <th scope="col" style="background-color: #eee">{{ $t('marketing.label.terminal_number') }}</th>
                    <th scope="col" style="background-color: #eee">{{ $t('marketing.label.period') }}</th>
                    <th scope="col" style="background-color: #eee">{{ $t('marketing.label.transaction_number') }}</th>
                    <th
                      scope="col"
                      style="background-color: #eee; border-radius: 16px 0 0 16px"
                    >
                      {{ $t('marketing.label.statistics_wage_title') }}
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="not-found" style="margin: 0 auto">
                <img src="@/assets/new/image/not-found_new.png" width="200" />
              </div>
            </div>
          </div>
        </div>

        <hr v-if="visitor.next_page_url || visitor.prev_page_url" />

        <pagination :data="visitor" :get_data="get_data" :perpage="perpage"></pagination>
      </div>

      <div id="overlay" v-if="status == 'loading'">
        <div
          class="p-3"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            color: gray;
            background-color: white;
          "
        >
          <div class="spinner-border text-success" role="status"></div>
          <span> لطفا صبر کنید </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiService } from "@/common/api.service";
import Pagination from "@/components/main/pagination";
import { userStatusStr, userVariant } from "@/constants/userStatus";
import { mapGetters } from 'vuex'
export default {
  name: "agentOpen",
  components: {
    Pagination,
  },
  data() {
    return {
      perpage: {
        value: 15,
      },
      visitor: null,
      status: "loading",
      terminal_number: null,
      from_date: null,
      filter_to_date: null,
      sort_field: null,
      marketingManage: {
        transactions_number: 0,
        total_transactions_amount: 0,
      },
      is_init: false,
      manageAccess: false,
      userStatusStr,
      userVariant,
      sort_sort: "desc",
      checked: false,
    };
  },
  watch: {
    checked(value) {
      this.$router.push("/pos/subsets/acceptor");
    },
  },
  computed: {
    query() {
      let res = "";
      if (this.terminal_number != null) {
        res = res + "&query[terminal_number]=" + this.terminal_number;
      }
      if (this.from_date != null) {
        res = res + "&query[from_date]=" + this.from_date;
      }
      if (this.filter_to_date != null) {
        res = res + "&query[to_date]=" + this.filter_to_date;
      }
      if (this.sort_field != null) {
        res = res + "&sort[field]=" + this.sort_field + "&sort[sort]=" + this.sort_sort;
      }

      return res;
    },
    queryInfo() {
      let posStatisticsQuery = "";

      posStatisticsQuery = {
        terminal_number: this.terminal_number,
        from_date: this.from_date,
      };

      return posStatisticsQuery;
    },
    ...mapGetters('marketing', ['pos_marketing_statistics','pos_visitor'])
  },
  methods: {
    toPersianDateFormat(val) {
      if (val == undefined || val == null || val == "") {
        return "";
      }

      val = String(val);

      return val.replace(/\-/g, "/");
    },
    async get_data(url, callback = () => {}) {
      this.status = "loading";
      ApiService.query(url + this.query + "&perpage=" + this.perpage.value).then(
        (json) => {
          this.visitor = json.data.data;
          this.status = "ok";
          this.is_init = true;
          callback();
        }
      );
      await this.$store.dispatch('marketing/fetchPosMarketingStatistics', this.queryInfo).then(() => {
        this.marketingManage = this.pos_marketing_statistics;
      })
    },
    resetQuery() {
      this.terminal_number = "";
      this.from_date = "";
      this.phone = "";
    },
    reset_and_get() {
      this.resetQuery();
      this.get_data(this.visitor.path + "?page=1");
    },
    sortBy(field) {
      this.sort_field = String(field);

      if (this.sort_sort == "desc") {
        this.sort_sort = "asc";
      } else {
        this.sort_sort = "desc";
      }

      this.get_data(this.visitor.path + "?page=1");
    },
  },
  async mounted() {
    await this.$store.dispatch('marketing/fetchPosVisitor').then(() => {
      this.visitor = this.pos_visitor;
      this.status = "ok";
      this.is_init = true;
    });

    await this.$store.dispatch('marketing/fetchPosMarketingStatistics');
    this.marketingManage = this.pos_marketing_statistics;
  },
};
</script>

<style scoped>
#overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.switch-div {
  width: fit-content;
  padding: 8px 27px;
  background: #fff;
  box-shadow: 0 0 7px 0 #9c9c9c5e;
  margin: 0 1rem -1rem 0;
  border-radius: 10px 10px 0 0;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6aad27;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 50px;
}

.slider.round:before {
  border-radius: 50px;
}
@media (max-width: 678px) {
  .mt-sm-size {
    margin: 1rem 0 !important;
  }
}
</style>
